export type RuntimeOS = 'macos' | 'ios' | 'windows' | 'linux' | 'chromeos' | 'android' | 'unknown'

interface NavigatorWithUserAgentData extends Navigator {
  userAgentData?: {
    platform?: string
  }
}

function normalizePlatform(value: string | undefined) {
  return value?.trim().toLowerCase() ?? ''
}

export function detectRuntimeOS(): RuntimeOS {
  if (typeof navigator === 'undefined') return 'unknown'

  const userAgentDataPlatform = normalizePlatform(
    (navigator as NavigatorWithUserAgentData).userAgentData?.platform
  )
  const platform = normalizePlatform(navigator.platform)
  const userAgent = normalizePlatform(navigator.userAgent)
  const source = `${userAgentDataPlatform} ${platform} ${userAgent}`

  if (source.includes('iphone') || source.includes('ipad') || source.includes('ipod')) {
    return 'ios'
  }

  if (source.includes('mac') && navigator.maxTouchPoints > 1) return 'ios'
  if (source.includes('mac')) return 'macos'
  if (source.includes('cros')) return 'chromeos'
  if (source.includes('win')) return 'windows'
  if (source.includes('android')) return 'android'
  if (source.includes('linux')) return 'linux'

  return 'unknown'
}

export const runtimeOS = detectRuntimeOS()
export const isAppleRuntimeOS = runtimeOS === 'macos' || runtimeOS === 'ios'

export const runtimeConfig = {
  environment: {
    os: runtimeOS,
    isAppleOS: isAppleRuntimeOS,
    shortcutModifierLabel: isAppleRuntimeOS ? 'Cmd' : 'Ctrl',
    altModifierLabel: isAppleRuntimeOS ? 'Option' : 'Alt',
  },
} as const
